<mat-list>
	<mat-radio-group
		allow-empty-selection="true"
		name="radio-group"
		(ionChange)="radioGroupChange($event)"
		#radioGroup>
		@for (item of radio_list; track item) {
<mat-list-item
		
			(ionFocus)="radioFocus()"
			(ionSelect)="radioSelect($event)"
			(ionBlur)="radioBlur()">
			<mat-label>{{ item.text }}</mat-label>
			<mat-radio-button
				slot="start"
				name="{{ item.name }}"
				value="{{ item.value }}"
				color="primary"
				disabled="{{ item.disabled }}"></mat-radio-button>
		</mat-list-item>
}
	</mat-radio-group>
</mat-list>
